import axiosInstance from './axios-instance';
import { isMutationSuccess } from './cache-utils';
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from './cache-invalidation';

const normalizeHeadrailEditPayload = (payload: any) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  const quantity =
    typeof payload.quantity === 'string' && payload.quantity.trim() === ''
      ? null
      : payload.quantity;

  return {
    ...payload,
    quantity,
  };
};

const addDraperyOrderHeadrail = async (payload: any) => {
  try {
    const response = await axiosInstance.post<any>('draperyOrderHeadrail/create', payload);
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const editDraperyOrderHeadrail = async (payload: any) => {
  try {
    const normalizedPayload = normalizeHeadrailEditPayload(payload);
    const response = await axiosInstance.post<any>('draperyOrderHeadrail/edit', normalizedPayload);
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(normalizedPayload, response.data), resolveClientId(normalizedPayload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export {
  addDraperyOrderHeadrail,
  editDraperyOrderHeadrail,
};
